import { Typography, Stack, Box } from "@mui/material"
import CircleIcon from "@mui/icons-material/Circle"
import { useTranslation } from "react-i18next"

import { ICE_TYPES } from "helpers/utils/icing"

const IcingDialogContent = () => {
  const { t } = useTranslation()

  return (
    <Stack gap={2} justifyContent="center" padding={1}>
      <Typography>{t("plots_descriptions.ICING_DIALOG.INTRO")}</Typography>

      <Typography>{t("plots_descriptions.ICING_DIALOG.SEVERITY_DESCRIPTION")}</Typography>

      <Stack gap={1.5}>
        {ICE_TYPES.map((type) => (
          <Box key={type.labelKey}>
            <Stack direction="row" alignItems="center" gap={1} mb={0.5}>
              <CircleIcon sx={{ fontSize: 8, color: type.color }} />
              <Typography sx={{ fontWeight: 500 }}>
                {t(type.labelKey)} ({t(type.shortLabelKey)})
              </Typography>
            </Stack>
            <Typography pl={2} variant="body2" color="text.secondary">
              {t(type.descriptionKey)}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Stack>
  )
}

export default IcingDialogContent
